WiseMetering.Model.Plan = WiseMetering.Model.extend({
    urlRoot: '/plans',

    features: () => [
        {
            description: i18next.t('plans.metering_data_analysis'),
            essentials: true,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.features.alarms'),
            essentials: true,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.features.opportunities'),
            essentials: true,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.invoices'),
            essentials: true,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.essentials_reports'),
            essentials: true,
            standard: false,
            advanced: false,
            premium: false
        },
        {
            description: i18next.t('plans.features.objectives'),
            essentials: false,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.utilities_tariffs_costs'),
            essentials: false,
            standard: true,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.features.standard_reports'),
            essentials: false,
            standard: true,
            advanced: false,
            premium: false
        },
        {
            description: i18next.t('plans.features.tenants'),
            essentials: false,
            standard: false,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.features.iso_50001_processes'),
            essentials: false,
            standard: false,
            advanced: true,
            premium: true
        },
        {
            description: i18next.t('plans.features.advanced_reports'),
            essentials: false,
            standard: false,
            advanced: true,
            premium: false
        },
        {
            description: i18next.t('plans.conditions.advanced_api'),
            essentials: false,
            standard: false,
            advanced: true,
            premium: false
        },
        {
            description: i18next.t('plans.features.premium_reports'),
            essentials: false,
            standard: false,
            advanced: false,
            premium: true
        },
        {
            description: i18next.t('plans.premium_api'),
            essentials: false,
            standard: false,
            advanced: false,
            premium: true
        },
        {
            description: i18next.t('plans.features.technical_support'),
            essentials: false,
            standard: false,
            advanced: false,
            premium: true
        },
        {
            description: i18next.t('plans.two_report_customizations_included'),
            essentials: false,
            standard: false,
            advanced: false,
            premium: true
        },
        {
            description: i18next.t('plans.integration_with_other_softwares'),
            essentials: false,
            standard: false,
            advanced: false,
            premium: true
        }
    ]
});
